import { Component, OnInit } from '@angular/core';
import { WebcamImage } from 'ngx-webcam';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'ark-my-profile-camera',
  templateUrl: './my-profile-camera.component.html',
  styleUrls: ['./my-profile-camera.component.scss']
})
export class MyProfileCameraComponent implements OnInit {
  public webcamImage: WebcamImage = null;
  
  constructor(
    public dialogRef: MatDialogRef<MyProfileCameraComponent>,
  ) { }

  ngOnInit() {
    
  }
  cameraImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage;
    this.dialogRef.close(this.webcamImage.imageAsDataUrl);
  }

  getUploadedImage(event) {
    let data = {
      image: event,
      type: 1
    }
    this.dialogRef.close(data);
  }

  close() {
    this.dialogRef.close();
  }

}
